
import { Component, Vue, Watch } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";
import { getInvoiceList } from "@/api/booking-order";
import Pagination from "@/components/Pagination/index.vue";
import { removeQuotation } from "@/api/inquiry";
import { updatePiRemark } from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
@Component({
  name: "customerIvManagement",
  components: {
    Pagination,
  },
})
export default class extends Vue{
  private listLoading = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private listParam = {
    customerId: null,
    customerKeyWord: null,
    customerNation: null,
    customerCode: null,
    generalKeyWord: null,
    groupKeyWord: null,
    trading: null,
    lastUpdateStart: null,
    lastUpdateEnd: null,
  };
  private searchForm = [
    // {
    //   label: "客人简称或编号",
    //   prop: "customerId",
    //   key: "customerId",
    //   type: "select",
    //   value: "",
    //   placeholder: "",
    //   remote: true,
    //   remote_method: this.searchCustomer,
    //   clearable: true,
    //   options: [],
    //   resetKey: { label: "abbreviation", value: "id" }
    // },
    {
      label: "客人简称或编号",
      prop: "customerKeyWord",
      key: "customerKeyWord",
      type: "input",
      value: "",
      placeholder: "请输入客人简称或编号",
    },
    {
      label: "最后更新时间",
      prop: "time",
      key: "time",
      type: "dateTimePicker",
      value: "",
    },
    {
      label: "是否只展示交易中客人",
      prop: "trading",
      key: "trading",
      type: "select",
      value: "",
      options: [
        { label: "是", value: true },
        { label: "否", value: false },
      ],
      placeholder: "请选择",
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "客人国家",
      prop: "customerNation",
      key: "customerNation",
      type: "input",
      value: "",
      placeholder: "请输入国家",
    },
    {
      label: "通用简称",
      prop: "generalKeyWord",
      key: "generalKeyWord",
      type: "input",
      value: "",
      placeholder: "请输入通用简称或编号",
      width: 400,
    },
    {
      label: "集团简称",
      prop: "groupKeyWord",
      key: "groupKeyWord",
      type: "input",
      value: "",
      placeholder: "请输入集团简称或编号",
      width: 400,
    },
  ];
  private tableCol = [
    {
      label: "客人编号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "客人简称",
      prop: "customerAbbreviation",
      key: "customerAbbreviation",
      show: true,
      disabled: false,
    },
    {
      label: "客人国家",
      prop: "customerNation",
      key: "customerNation",
      show: true,
      disabled: false,
    },
    {
      label: "通用编号",
      prop: "generalCode",
      key: "generalCode",
      show: true,
      disabled: false,
    },
    {
      label: "通用简称",
      prop: "generalAbbreviation",
      key: "generalAbbreviation",
      show: true,
      disabled: false,
    },
    {
      label: "集团编号",
      prop: "groupCode",
      key: "groupCode",
      show: true,
      disabled: false,
    },
    {
      label: "集团简称",
      prop: "groupAbbreviation",
      key: "groupAbbreviation",
      show: true,
      disabled: false,
    },
    {
      label: "结算货币单位",
      prop: "currencyUnit",
      key: "currencyUnit",
      show: true,
      disabled: false,
    },
    {
      label: "已清账",
      prop: "clearedQuantity",
      key: "clearedQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "已完成",
      prop: "completedQuantity",
      key: "completedQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "交易中",
      prop: "tradingQuantity",
      key: "tradingQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "未清账IV金额",
      prop: "outstandingAmount",
      key: "outstandingAmount",
      show: true,
      disabled: false,
    },
    {
      label: "未分配收汇单金额",
      prop: "unallocatedAmount",
      key: "unallocatedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "最后更新时间",
      prop: "lastUpdateTime",
      key: "lastUpdateTime",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      // type: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "IV管理",
          code: "",
          click: "handleToIVM",
        },
        {
          name: "收汇单",
          code: "",
          click: "handleToSHD",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;
  created() {
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    // this.searchCustomer();
    this.getList();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = true;
    const { total, content }: any = await getInvoiceList(params);
    this.table.total = +total;
    this.table.list = content;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }
  private isExporting = false;

  // 导出
  private handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `客人IV管理-${new Date()}`
    );
    this.isExporting = false;
  }

  // 跳转IV管理
  private handleToIVM(row) {
    console.log("点击跳转查看详情", row.row);
    this.$router.push(
      `/customer-iv-managementInfo?customerId=${row.row.customerId}`
    );
  }
  // 跳装 收汇单 并且携带客人参数
  private handleToSHD(row) {
    this.$router.push(
      `/collectionManagement?customerID=${row.row.customerId}`
    );
  }

  private async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 填写备注
  private async handleRemark(item) {
    try {
      let data = {
        remark: item.remark
      }
      await updatePiRemark(item.customerId, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }
  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  private querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.lastUpdateStart = time[0];
      rest.lastUpdateEnd = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }
  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private handleCustomer() {
    console.log(1);
  }
}
